import React, { useEffect, useState } from 'react';
import './DynamicList.css';

import { jsPDF } from "jspdf";

import solar_power_img from '../assets/material_icons/solar_power.svg';
import roof_img from '../assets/material_icons/roof.svg';
import grid_img from '../assets/material_icons/grid_4x4.svg';
import offset_img from '../assets/material_icons/offset.svg';
import table_rows_img from '../assets/material_icons/table_rows.svg';
import table_img from '../assets/material_icons/table.svg';
import add_img from '../assets/material_icons/add.svg';
import mop_img from '../assets/material_icons/mop.svg';

import more_horiz_img from '../assets/material_icons/more_horiz.svg';
import sync_img from '../assets/material_icons/sync.svg';
import delete_img from '../assets/material_icons/delete.svg';
import reset_image_img from '../assets/material_icons/reset_image.svg';
import pdf_img from '../assets/material_icons/picture_as_pdf.svg';
import hide_img from '../assets/material_icons/hide.svg';
import file_save_img from '../assets/material_icons/file_save.svg';
import logo_img from '../assets/logos/horisontal_logo.png';


function DynamicList (
  {setDrawTrigger,
    BOQData,
    setBOQData,
    pdfName,
    setPDFName,
    mainWidth,
    setMainWidth,
    mainHeight,
    setMainHeight,
    subWidth,
    setSubWidth,
    subHeight,
    setSubHeight,
    columnWidth,
    setColumnWidth,
    internalVerticalSpacing,
    setInternalVerticalSpacing, 
    internalHorizontalSpacing,
    setInternalHorizontalSpacing,

    spacingBetweenColumns,  
    setSpacingBetweenColumns,
    spacingFromTopBottom,
    setSpacingFromTopBottom,

    spacingFromSide,
    setSpacingFromSide,
    mountingCentre,
    setMountingCentre,
    noPanels,
    setNoPanels,
    noBrackets,
    setNoBrackets,
    noEarthClips,
    setNoEarthClips,
    noAntiTamperClips,
    setNoAntiTamperClips,
    noEndSpacers,
    setNoEndSpacers,
    noOfRoofs, setNoOfRoofs,
    exportToPDF,
    deviceType,
    totalPanels,
    totalBrackets,
    totalEarthClips,
    totalEndSpacers,
    totalAntiTamperClips,
    setTotalAntiTamperClips,
    setTotalBrackets,
    setTotalEarthClips,
    setTotalEndSpacers,
    setActiveTab,
    showRibbonContent,
    setShowRibbonContent,
    paramsNoColumns,
    paramsNoRows,
    paramsNoPanels,
    handleExportCoords,
    shouldExportToCoords, 
    setShouldExportToCoords,
    maxPanels,
    setMaxPanels,

  }
) {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalName, setModalName] = useState('');
  const [activeIndex, setActiveIndex] = useState(null);
  const [shouldExport, setShouldExport] = useState(false);

  useEffect(() => {
    setPDFName('Roof: ' + (noOfRoofs));}
  , [noOfRoofs]);




  useEffect(() => {
    if (shouldExport) {
      const timer = setTimeout(() => {
        exportToPDF();
        setShouldExport(false); // Reset
      }, 100); // Allow short delay for render (tweak this if needed)
  
      return () => clearTimeout(timer);
    }
  }, [shouldExport]);

  useEffect(() => {
    if (shouldExportToCoords) {
      const timer = setTimeout(() => {
        handleExportCoords();
        setShouldExportToCoords(false); // Reset
      }, 100); // Allow short delay for render (tweak this if needed)
  
      return () => clearTimeout(timer);
    }
  }, [shouldExportToCoords]);


  const handleRemove = (index) => {
    setBOQData(prev => prev.filter((_, i) => i !== index));
    setPDFName('Roof: ' + (noOfRoofs - 1));
    setMainWidth(15000);
    setMainHeight(8000);
    setSubWidth(2000);
    setSubHeight(1000);
    setColumnWidth(2);
    setInternalVerticalSpacing(17);
    setInternalHorizontalSpacing(0);
    setSpacingBetweenColumns(30);
    setSpacingFromTopBottom(300);
    setSpacingFromSide(300);
    setMountingCentre(1400);
    setNoOfRoofs(prev => prev - 1);
    setDrawTrigger(prev => !prev); // Trigger the draw
  }


    const handlePreview = (item) =>{
      setMainWidth(item.mainWidth);
      setMainHeight(item.mainHeight);
      setSubWidth(item.subWidth);
      setSubHeight(item.subHeight);
      setColumnWidth(item.columnWidth);
      setMaxPanels(item.maxPanels)
      setInternalVerticalSpacing(item.internalVerticalSpacing);
      setInternalHorizontalSpacing(item.internalHorizontalSpacing);
      setSpacingBetweenColumns(item.spacingBetweenColumns);
      setSpacingFromTopBottom(item.spacingFromTopBottom);
      setSpacingFromSide(item.spacingFromSide);
      setMountingCentre(item.mountingCentre);
      setNoPanels(item.noPanels);
      setNoBrackets(item.noBrackets);
      setNoEarthClips(item.noEarthClips);
      setNoAntiTamperClips(item.noAntiTamperClips);
      setNoEndSpacers(item.noEndSpacers);
      setPDFName(item.pdfName);
      setDrawTrigger(prev => !prev); // Trigger the draw
    }

    const handleExportItemToDrawing =(item) =>{
      handlePreview(item);
      setShouldExport(true);
    
    }

    const ExportItemToCoords =(item) =>{
      handlePreview(item);
      setDrawTrigger(prev => !prev); // Trigger the draw
      setShouldExportToCoords(true);
    
    }



    // const handleExportBOQ = () => {


    //   const doc = new jsPDF();
    //   const startX = 10;
    //   const startY = 20;
    //   const rowHeight = 10;
    //   const colWidths = [50, 30, 30, 30, 30, 30,30];
    //   const headers = ["Name", "Panels", "Brackets", "Earth\nClips", "End\nSpacers", "Anti\nTamper\nClips"];

    //     // Draw header
    //     let currentX = startX;
    //     headers.forEach((header, i) => {
    //       doc.rect(currentX, startY, colWidths[i], rowHeight*3);
    //       doc.text(header, currentX + 2, startY + 7);
    //       currentX += colWidths[i];
    //     });

    //     // Draw data rows
    //     let rowY = startY + rowHeight*3;
    //       BOQData.forEach((item) => {
    //         const values = [item.pdfName, item.noPanels, item.noBrackets, item.noEarthClips, item.noEndSpacers, item.noAntiTamperClips];
    //         let x = startX;
    //         values.forEach((val, i) => {
    //           doc.rect(x, rowY, colWidths[i], rowHeight);
    //           doc.text(String(val), x + 2, rowY + 7);
    //           x += colWidths[i];
    //         });
    //         rowY += rowHeight;
    //       });


    //       const totals = ['Total', totalPanels, totalBrackets, totalEarthClips, totalEndSpacers, totalAntiTamperClips];


    //       // Draw totals row
    //       let x = startX;
    //       totals.forEach((val, i) => {
    //         doc.rect(x, rowY, colWidths[i], rowHeight);
    //         doc.text(String(val), x + 2, rowY + 7);
    //         x += colWidths[i];
    //       });


    

    //     doc.save("table.pdf");
    //   };
              
    
    const handleExportBOQ = async () => {
      let IBRcounter = 0;
      let CORcounter = 0;
      let KlipCounter = 0;

      BOQData.forEach((item) => {
        if (item.bracketType === 'IBR') {
          IBRcounter += item.noBrackets;
        } else if (item.bracketType === 'Corrugated') {
          CORcounter += item.noBrackets;
        }
        else if (item.bracketType === 'KlipOn') {
          KlipCounter += item.noBrackets;
        }
      });


       // Timestamp
       const now = new Date();
       const date = now.toISOString().slice(0, 10);
       const time = now.toTimeString().slice(0, 8).replace(/:/g, '-');
       const timetext = now.toTimeString().slice(0, 8);
       // Initialize PDF
      const doc = new jsPDF('p', 'mm', 'a4');
      const pageHeight = doc.internal.pageSize.height;
      const pageWidth = doc.internal.pageSize.width;
    
      const startX = 10;
      const startY = 40; // Adjust for header
      const rowHeight = 10;
      const colWidths = [30, 20,22,25, 22, 22, 22, 22];
      const headers = ["Name", "Panels", "Brackets\n(IBR)","Brackets\n(Corrugated)","Brackets\n(KlipOn)", "EarthClips", "End\nSpacers", "Anti\nTamper\nClips"];
      const headerHeight = rowHeight * 3;
      const marginBottom = 20;
    
      let page = 1;
      let rowY = startY;
    
      const addHeader = () => {
        // Header image
        doc.setFont("helvetica", "bold")
        doc.addImage(logo_img, 'PNG', 10, 10, 42, 42/1829*666 );
        // Header text
        doc.setFontSize(14);
        doc.text("Bill of Quantities ", 60, 20);
        doc.setFontSize(10);
        doc.text(`Generated on: ${date} ${timetext}`, pageWidth - 130, pageHeight - 10);
        doc.text(`Page ${page}`, pageWidth - 30, pageHeight - 10);
      };


    
      const addTableHeader = () => {
        doc.setFont("helvetica", "bold")
        let currentX = startX;
        headers.forEach((header, i) => {
          doc.rect(currentX, rowY, colWidths[i], headerHeight);
          doc.text(header, currentX + 2, rowY + 7);
          currentX += colWidths[i];
        });
        rowY += headerHeight;
      };
    
      const checkAddPage = (nextPage=null) => {
        if (rowY + rowHeight + marginBottom > pageHeight) {
          doc.addPage();
          page++;
          rowY = startY;
          addHeader();
          if (nextPage === null) {
            addTableHeader();
          }
          
        }
      };
    
      // Start with first page
      addHeader();
      addTableHeader();
    
      doc.setFont("helvetica", "normal")
      // Draw data rows
      BOQData.forEach((item) => {
        checkAddPage();
        const values = [item.pdfName, item.noPanels, item.bracketType==='IBR'? item.noBrackets: 0, item.bracketType==='Corrugated'? item.noBrackets: 0,item.bracketType==='KlipOn'? item.noBrackets: 0 , item.noEarthClips, item.noEndSpacers, item.noAntiTamperClips];
        let x = startX;
        values.forEach((val, i) => {
          doc.rect(x, rowY, colWidths[i], rowHeight);
          doc.text(String(val), x + 2, rowY + 7);
          x += colWidths[i];
        });
        rowY += rowHeight;
      });
    
      // Totals row
      doc.setFont("helvetica", "bold")
      const totals = ['Total', totalPanels, IBRcounter,CORcounter,KlipCounter, totalEarthClips, totalEndSpacers, totalAntiTamperClips];
      checkAddPage();
      let x = startX;
      totals.forEach((val, i) => {
        doc.rect(x, rowY, colWidths[i], rowHeight);
        doc.text(String(val), x + 2, rowY + 7);
        x += colWidths[i];
      });
      doc.setFont("helvetica", "normal")

      rowY += rowHeight;
      rowY += rowHeight;
      doc.text('THIS SPACE IS LEFT BLANK INTENTIONALLY, PLEASE TURN OVER', startX, rowY);
      doc.addPage(); page++; rowY = startY;
      addHeader();

      rowY += rowHeight;
      doc.setFont('helvetica', 'bold'); doc.setFontSize(14);
      doc.text('Input Parameters: ' , startX+2 , rowY);

      BOQData.forEach((item) => {
        const nextPage = true;
        checkAddPage(nextPage);
        rowY += rowHeight;
        const values = [item.pdfName];
        let x = startX;
        values.forEach((val, i) => {
          doc.setFont('helvetica', 'bold'); doc.setFontSize(14);
          doc.rect(x, rowY, pageWidth - startX * 2, rowHeight);
          doc.text(String(item.pdfName) + ' ('+String(item.bracketType) +')' , x + 2, rowY + 7);
          rowY += rowHeight;
          doc.rect(startX, rowY+2, pageWidth - startX * 2, headerHeight);
          rowY += rowHeight;
          doc.setFont('helvetica', 'normal'); doc.setFontSize(12);
          doc.text('Roof: ' , startX+2, rowY);
          doc.text('('+ String(item.mainHeight/1000) +'x' + String(item.mainWidth/1000)+') m (HxW)', startX+60, rowY);
          
          doc.rect(startX, rowY+2, pageWidth - startX * 2, headerHeight);
          rowY += rowHeight;
          doc.text('Panel: ' , startX+2, rowY);
          doc.text('('+ String(item.subHeight) +'x' + String(item.subWidth)+') mm (HxW) ' + String((item.panelName==='Please Select')? '' : item.panelName ), startX+60, rowY);
          
          doc.rect(startX, rowY+2, pageWidth - startX * 2, headerHeight); 
          rowY += rowHeight;
          doc.text('Panels: ' , startX+2, rowY);
          doc.text('('+ String(item.paramsNoColumns) +'x' +String(item.columnWidth)+') Columns x '+String(item.paramsNoRows) +' Rows = '+String(item.paramsNoPanels)+' Panels', startX+60, rowY);
          
          doc.rect(startX, rowY+2, pageWidth - startX * 2, headerHeight);
          rowY += rowHeight;
          doc.text('Walkway Spacing: ' , startX+2, rowY);  
          doc.text( String(item.spacingBetweenColumns)+ ' mm', startX+60, rowY);
      
          doc.rect(startX, rowY+2, pageWidth - startX * 2, headerHeight);
          rowY += rowHeight;
          doc.text('Mounting Centres: ' , startX+2, rowY);
          doc.text( String(item.mountingCentre)+ ' mm', startX+60, rowY);
    
          doc.rect(startX, rowY+2, pageWidth - startX * 2, headerHeight);
          rowY += rowHeight;
          doc.text('Horisontal Spacing: ' , startX+2, rowY);
          doc.text( String(item.internalHorizontalSpacing)+ ' mm', startX+60, rowY);
          
          doc.rect(startX, rowY+2, pageWidth - startX * 2, headerHeight);
          rowY += rowHeight;
          doc.text('Bracket Spacing: ' , startX+2, rowY);
          doc.text( String(item.internalVerticalSpacing)+ ' mm', startX+60, rowY);
          
          //doc.rect(startX, rowY+2, pageWidth - startX * 2, headerHeight);
          rowY += rowHeight;
          doc.text('Offset from Top/bottom: ' , startX+2, rowY);
          doc.text( String(item.spacingFromTopBottom)+ ' mm', startX+60, rowY);
          
          // doc.rect(startX, rowY+2, pageWidth - startX * 2, headerHeight);
          rowY += rowHeight;
          doc.text('Offset from Side: ' , startX+2, rowY);
          doc.text( String(item.spacingFromSide)+ ' mm', startX+60, rowY);

        });
        rowY += rowHeight;
      });
      


      rowY += rowHeight;
      doc.setFont('helvetica', 'bold'); doc.setFontSize(14);
      doc.text('DISCLAIMER', startX+2 , rowY);
      

      rowY += rowHeight;

      doc.setFont('helvetica', 'normal'); doc.setFontSize(10);

      doc.text(  `This document is generated based on user-provided input.
It is the sole responsibility of the user to ensure all measurements are accurate and 
verified on site. DeoSolar accepts no liability for errors resulting from incorrect or
incomplete input. Use of this drawing is at the client's own risk. DeoSolar and its 
logo are the property of the company. All content is protected by copyright and may
not be reproduced or distributed without permission.`, startX, rowY);
rowY += rowHeight;
rowY += rowHeight;
rowY += rowHeight;
rowY += rowHeight;
rowY += rowHeight;

      //Export
      doc.save(`DeoSolar_BOQ_${date}_${time}.pdf`);
    };


    
    return (
      <div className="dynamic-list-container"
        style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
      >


        <div className="footer-row"
        style={{alignItems: (deviceType !='phone') ?  'flex-start':'center' }}>

            <button className="action-panel-button"  onClick={handleExportBOQ} disabled={BOQData.length ===0}>
              <img className="action-panel-image" src={file_save_img} alt="Export"  /> 
              <p className='action-panel-button-text'>
                Export BOQ
              </p>
            </button>

            <button className="action-panel-button"  onClick={() => {
                    setActiveTab('main')
            }}>
              <img className="action-panel-image" src={add_img} alt="Add"  />
               <p className='action-panel-button-text'>Add Roof</p>
            </button>

        </div>

                  

        <div 
          style={{ flex: 1,  maxHeight: '250px',overflowY: 'auto',  padding: '2px' ,paddingLeft: (deviceType != 'phone')? '15%':'2px',margin: '0px',marginBottom: '16px', border: 'none',backgroundColor: 'rgba(255, 255, 255, 0.3)'}}
        >
          <div className="item-values" style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
            <div className="item-cell"  style={{ fontWeight:'600', margin:'0px',color: 'white',  }}>Roof</div>
            <div className="item-cell"  style={{fontWeight:'600', margin:'0px',color: 'white', }}>Panels</div>
            <div className="item-cell"  style={{fontWeight:'600', margin:'0px',color: 'white', }}>Brackets</div>
            <div className="item-cell"  style={{fontWeight:'600', margin:'0px',color: 'white', }}>Earth Clips</div>
            {(deviceType !='phone') && (
                          <>
            <div className="item-cell"  style={{fontWeight:'600', margin:'0px',color: 'white', }}>End Spacers</div>
            <div className="item-cell"  style={{fontWeight:'600', margin:'0px',color: 'white',}}>Anti Tamper Clamps</div>
                          </>
            )}
          </div>

          {BOQData.length === 0 && (
            <p>No roofs added to BOQ, Please add a roof ('+ BOQ') to export BOQ.</p>)}

          <div className="item-list" >
            {BOQData.map((item, index) => {
              const isActive = activeIndex === index;
              return (
                <div  className="item-row-wrapper" key={index}>
                  <div               
                      key={index}
                      className="item-row"
                      style={{
                      position: 'relative',
                      marginBottom: '8px',
                      padding: '8px',
                      background: '#fff',
                      cursor: 'pointer',
                      overflow: 'hidden',
                      border: '1px solid #ddd',
                      borderRadius: '4px'
                    }}
                    onClick={() => setActiveIndex(isActive ? null : index)}
                  >
                    
                    <div className="item-values" 
                      style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                      <div className="item-cell"style={{width:'60px'}}>{item.pdfName + ' (' +item.bracketType.slice(0,3)+')'}</div>
                      <div className="item-cell">{item.noPanels}</div>
                      <div className="item-cell">{item.noBrackets}</div>
                      <div className="item-cell">{item.noEarthClips}</div>
                      {(deviceType !='phone') && (
                          <> <div className="item-cell">{item.noEndSpacers}</div>
                      <div className="item-cell">{item.noAntiTamperClips}</div>
                          </>
                      )}
                    </div>
                    <div className="item-actions"
                                    style={{
                                      position: 'absolute',
                                      top: 0,
                                      right: isActive ? 0 : '-100%',
                                      height: '100%',
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '8px',
                                      padding: '0 8px',
                                      background: '#f5f5f5',
                                      transition: 'right 0.3s ease'
                                    }}>
                      <button className= 'slider-button' onClick={() => setActiveIndex(isActive ? null : index)} style={{background: 'var(--secondary-color)'}}>
                        <img className="action-panel-image" src={isActive ?  hide_img : more_horiz_img} alt="More"  />
                      </button>

                      <button className= 'slider-button' disabled={noOfRoofs==0} onClick={() => handlePreview(item,() => setDrawTrigger(prev => !prev))}>
                        <img className="action-panel-image" src={reset_image_img} alt="Preview"  />
                        </button>
                      <button className= 'slider-button' disabled={noOfRoofs==0} onClick={() => handleExportItemToDrawing(item)}>
                        <img className="action-panel-image" src={pdf_img} alt="ExportDrawing"  />
                        </button>
                      <button className= 'slider-button' disabled={noOfRoofs==0} onClick={() => ExportItemToCoords(item)}>
                        <img className="action-panel-image" src={file_save_img} alt="ExportCoords"  />
                      </button>

                      <button className= 'slider-button' style={{background: 'var(--error-color)'}} disabled={noOfRoofs==0} onClick={() => handleRemove(index)}>
                        <img className="action-panel-image" src={delete_img} alt="Remove"  />
                      </button>
                    </div>
                  </div>
                  {!isActive && (
                    <button className= 'slider-button' onClick={() => setActiveIndex(isActive ? null : index)} style={{background: 'var(--secondary-color)', margin:'2px 2px 8px', border:'0px', alignSelf:'center', padding:'4px'}}>
                      <img className="action-panel-image" src={isActive ?  hide_img : more_horiz_img} alt="More"  />
                    </button>
                  )}
                </div>
            )})}
          </div>




        </div>

      </div>
    );
  }

export default DynamicList;
